module.exports = __webpack_public_path__ + "img/ALC200-1.9b9ac7c3.jpg";